export default __webpack_public_path__ + "static/media/green_marker.11bd0d90.svg";